import { FC, useState } from 'react'
import { Box, Collapse, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useApplicationOwners } from 'hooks'
import { Skeleton } from '@mui/material'
import { PersonDetails } from './PersonDetails'

export type OwnersProps = {
    applicationId: string
}

export const Owners: FC<OwnersProps> = (props) => {
    const { t } = useTranslation()

    const [checked, setChecked] = useState(false)
    const theme = useTheme()
    const handleChange = () => {
        setChecked((prev) => !prev)
    }

    const { data, isInitialLoading } = useApplicationOwners(props.applicationId)

    if (isInitialLoading) {
        return (
            <Box paddingRight={4}>
                <Skeleton height={40} />
            </Box>
        )
    } else {
        if (data.length === 0) {
            return <Box paddingLeft={'4px'}>-</Box>
        }

        const owner = data.length > 0 && data[0]

        const showMoreCount = data.length - 1
        return (
            <Box
                sx={{
                    position: 'relative',
                }}
            >
                <PersonDetails size="medium" person={owner} />

                <Collapse in={checked} collapsedSize={0}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '150px',
                            overflow: 'auto',
                        }}
                    >
                        {data &&
                            data
                                .slice(1, data.length)
                                .map((o: any) => (
                                    <PersonDetails
                                        key={o.id}
                                        size="medium"
                                        person={o}
                                    />
                                ))}
                    </Box>
                </Collapse>

                {data && data.length > 1 && (
                    <Box
                        sx={{
                            paddingTop: theme.spacing(1.5),
                            '& > button': {
                                backgroundColor: 'transparent',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: 'none',
                                color: theme?.palette?.primary?.main,
                                '&:hover': {
                                    cursor: 'pointer',
                                },
                            },
                        }}
                    >
                        <button onClick={handleChange} aria-expanded={checked}>
                            {checked
                                ? `- ${t('Common_ShowLess')}`
                                : `+ ${showMoreCount} ${t('Common_More')}`}
                        </button>
                    </Box>
                )}
            </Box>
        )
    }
}
